
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/replacements",
      function () {
        return require("private-next-pages/replacements.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/replacements"])
      });
    }
  